import Vue from 'vue';
import Component from 'vue-class-component';
import ABaseComponent from 'Components/Base/ABaseComponent';
import { Prop } from 'vue-property-decorator';
import { CartClient, CopyItemsFromExistingOrderArgs } from "Api/DynamicwebApi"
import { State } from 'vuex-class';
import { CartState } from 'Store/types';
import cart from 'Store/cart/cart';
import ApiProvider from 'Api/ApiProvider';
@Component({})
export class ReorderComponent extends ABaseComponent {
    @Prop()
    orderId: string;
    @Prop()
    orderSecret: string;


    get cart(){
        return cart.state;
    }

    saved: boolean = false;

    created() {
        this.setLoaded();
    }

    reloadOrderLines() {
        this.setLoading();
        const client = ApiProvider.getDwApiClient();
        const args = new CopyItemsFromExistingOrderArgs({
            orderId: this.orderId,
            orderSecret: this.orderSecret
        });
        client.copyItemsFromExistingOrder(args).then((res) => {
            cart.dispatchFetchCart();
            this.setLoaded();
            this.saved = true;
        }).catch(e => this.setError(e));
    }
}
Vue.component('reorder', ReorderComponent);